import { InfoIcon } from '@/assets/icons/info-icons/info';
import { Banner } from '@/components/basicComponents/banner';
import Button from '@/components/basicComponents/button';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { useErrorMessages } from '@/hooks/i18n';
import { themeVar } from '@/styles/theme';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { useState } from 'react';
import styled from 'styled-components';

interface ExportCSVProps {
  isOpen: boolean;
  planId: string | null;
  onClose: () => void;
}

const ExportCSV = ({ isOpen, planId, onClose }: ExportCSVProps) => {
  const { default: defaultErrorMessage } = useErrorMessages();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleDownload = async () => {
    try {
      setLoading(true);
      setErrorMessage(null);
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/pacing-model/export`,
        {
          planId
        },
        {
          headers: { authorization: `Bearer ${localStorage.getItem('token')}` },
          responseType: 'blob'
        }
      );

      fileDownload(response.data, 'commitment-plan.csv');
    } catch (error) {
      console.error(error);
      setErrorMessage(defaultErrorMessage);
    } finally {
      setLoading(false);
    }
  };

  if (!planId) return <></>;

  return (
    <ModalWrappedContent title="Export" isOpen={isOpen} onClose={onClose} showCancelButton={false}>
      {errorMessage && (
        <ErrorBannerWrapper>
          <Banner icon={<InfoIcon width={26} height={26} />} title="Error" description={errorMessage} bgColor={themeVar('context.error')} />
        </ErrorBannerWrapper>
      )}
      <ModalBody>
        <Button styleType={loading ? 'disabled' : 'default'} size="md" onClick={handleDownload} isLoading={loading}>
          Generate CSV
        </Button>
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default ExportCSV;

const ModalBody = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
`;

const ErrorBannerWrapper = styled.div`
  margin-bottom: 20px;
`;
